import { paths } from 'src/routes/paths';

export const serviceNavItems = [
  { key: 'agents', path: paths.services.agents },
  { key: 'tools', path: paths.services.tools },
  { key: 'implementations', path: paths.services.implementations },
  { key: 'migrations', path: paths.services.migrations },
  { key: 'secureAi', path: paths.services.secureAi },
] as const;
